// bookings/{bookingId} — see src/services/bookingService.js and
// src/Auth/host/hostService.js.

const { BookingStatus } = require('../status/bookingStatus');

// Fields: mealId, guestId, hostId, status, bookedAt, cancelledAt,
// userAttendedMeal.

const isCancellable = (booking) => booking.status === BookingStatus.CONFIRMED;

const isReviewable = (booking, reviewerRole) => {
  if (reviewerRole === 'guest') return Boolean(booking.userAttendedMeal);
  return true;
};

module.exports = { isCancellable, isReviewable };
